import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { FeedbackForm } from "@/components/feedback/FeedbackForm";
import { useFeedbackContext } from "@/context/FeedbackContext";

export function FeedbackWidget() {
 const { isOpen, closeFeedback } = useFeedbackContext();

 return (
 <Sheet
 open={isOpen}
 onOpenChange={(open) => {
 if (!open) closeFeedback();
 }}
 >
 <SheetContent
 side="right"
 className="w-full sm:max-w-lg"
 data-feedback-sheet
 >
 <SheetHeader>
 <SheetTitle>Send feedback</SheetTitle>
 </SheetHeader>

 <div className="mt-4">
 <FeedbackForm />
 </div>
 </SheetContent>
 </Sheet>
 );
}
